
export const UsuarioEntity = {
    id: null,
    username: '',
    email: '',
    password: '',
    nombre: '',
    apellido: '',
    docIdentidad: '',
    fecNacimiento: '',
    nroTelefono: '',
    genero: '',
    estado: true,
    role: ''
};
